"use strict";

define('rs/models/document.lock',['rs/models/lock', 'rs/helper', 'rs/models/document', 'rs/models/person'], function (LockModel, helper, Document, Person) {
  var DocumentLockModel = LockModel.extend({
    properties: ['userId'],
    initialize: function initialize(domainId, userId) {
      this.setUserId(userId);
      this._super(domainId);
    },
    _requestLocksForDomain: function _requestLocksForDomain(domainId) {
      return Document.requestSectionLockList(domainId);
    },
    _requestLock: function _requestLock(objectId) {
      return Document.requestSectionLock(this.getDomainId(), objectId);
    },
    _requestUnlock: function _requestUnlock(objectId) {
      return Document.requestSectionUnlock(this.getDomainId(), objectId);
    },
    _lockIsOwned: function _lockIsOwned(lockObj) {
      return lockObj.updateUserAuthId == this.getUserId();
    },
    _getObjectIdFromLock: function _getObjectIdFromLock(lockObj) {
      return lockObj.templateObjectId;
    },
    getLockOwnerSync: function getLockOwnerSync(objectId) {
      var lock = this.getLockForDomain(objectId);
      return lock ? lock.updateUser : '';
    }
  }, {});
  return DocumentLockModel;
});

